(function($) {

	var gMaps = null;

	$(window).on(window.ZP_LOAD, function () {
		init();
	});

	function init()  {
		handle();
	}

	function handle() {
		if(typeof google === 'undefined') {
			setTimeout(handle, 200);
		} else {
			build();
		}
	}

	function build() {
		var maps = $(".zp_google_map");
		if(maps.length > 0) {
			gMaps = new Array();
			maps.each(function(index, element){
				var map = $(element);
				if(!map.hasClass("zp-loaded")) {
					map.addClass("zp-loaded");
					var mapData = JSON.parse(map.attr("data-settings"));
					var markerInteraction = mapData.markerType;
					var gMap = new google.maps.Map(map.find("> .map").get(0), mapData);
					//$.data(map, "fitBounds", fitBounds());
					var gMarkers = new Array();
					var markers = map.find("> .zp_google_map_element");

					markers.each(function(index, element) {
						var marker = $(element);
						var markerData = JSON.parse(marker.attr("data-marker"));
						var markerPinData = {};
						markerPinData.position = markerData.coord;
						markerPinData.title = marker.find("> .title").text();
						markerPinData.marker = markerData.marker;
						markerPinData.content =  new google.maps.InfoWindow({content: marker.find("> .content").html()});
						markerPinData.link = markerData.link;
						markerPinData.boundsDisable = markerData.boundsDisable;

						var icon = markerData.icon;
						if(icon == "") {
							if(mapData.defaultIcon != "") {
								icon = mapData.defaultIcon;
							}
						}
						if(markerData.iconSize != "") {
							icon = {
								url: icon,
								scaledSize: new google.maps.Size(markerData.iconSize.width, markerData.iconSize.height)
							};
						} else if(mapData.defaultIconSize != "") {
							icon = {
								url: icon,
								scaledSize: new google.maps.Size(mapData.defaultIconSize.width, mapData.defaultIconSize.height)
							};
						}
						if(icon != "") {
							markerPinData.icon = icon;
						}

						markerPinData.map = gMap;
						var m = new google.maps.Marker(markerPinData);
						m.domHolder = element;
						gMarkers.push(m);
						if(markerInteraction == "click" || ($("html").hasClass("zp-touch") && markerInteraction == "hover") || markerData.link != "") {
							m.addListener('click', infoBoxOpen);
						} else if(markerInteraction == "hover") {
							m.addListener('mouseover', infoBoxOpen);
							m.addListener('mouseout', infoBoxClose);
						}
					});

					google.maps.event.addListener(gMap, 'tilesloaded', function() {
						if(mapData.center) {
							fitBounds();
						}
						gMap.boundsDisableLoad = false;
						google.maps.event.clearListeners(gMap, 'tilesloaded');
					});

					gMap.markers = gMarkers;
					gMaps.push(gMap);

					map.data("dataMap", gMap);
				}
			});

			$(window).on("resize", resize);
			resize();
		}

	}

	function resize() {
		var maps = $(".zp_google_map");
		var win = $(window);
		if(maps.length > 0) {
			maps.each(function(index, element){
				var map = $(element);
				var mapData = JSON.parse(map.attr("data-settings"));
				if(mapData.fullheight) {
					map.find(".map").css({"height" : win.height() + "px"});
				}

				google.maps.event.trigger(map.data().dataMap, 'resize');
			});
		}
		fitBounds();
	}

	function infoBoxOpen() {
		var _this = $(this);
		var data = _this.get(0);
		var domHolder = data.domHolder;
		var domMap = $(domHolder).closest(".zp_google_map");
		var map = domMap.data();
		var dataMap = map.dataMap;
		if(data.link != "") {
			window.open(data.link.href, data.link.target);
		} else {
			var markers = dataMap.markers;
			var j = 0;
			while(j < markers.length) {
				var mk = markers[j];
				if(mk != data) {
					mk.content.close();
				} else {
					mk.content.open(dataMap, mk);
					if(dataMap.centerType) {
						dataMap.setZoom(12);
						dataMap.setCenter(mk.getPosition());
					}
				}
				j = j + 1;
			}
		}
		event.preventDefault();
		event.stopPropagation();
	}

	function infoBoxClose() {
		var _this = $(this);
		var data = _this.get(0);
		data.content.close();
	}


	function fitBounds() {
		if(gMaps != null) {
			var i = 0;
			while(i < gMaps.length) {
				var map = gMaps[i];
				if(!map.boundsDisableLoad) {
					if(map.centerMap) {
						var center = map.center;
						if(map.bounds) {
							var markers = map.markers;
							var bounds = new google.maps.LatLngBounds();
							var j = 0;
							while (j < markers.length) {
								var m = markers[j];
								if(!m.boundsDisable) {
									if(m.getVisible()) {
										bounds.extend(m.getPosition());
									}
								}
								j = j + 1;
							}
							map.fitBounds(bounds);
							map.setCenter(bounds.getCenter());
						} else {
							map.setCenter(center);
						}
						if(map.centerMapMaxZoom != "") {
							if(map.getZoom() > map.centerMapMaxZoom) {
								map.setZoom(map.centerMapMaxZoom);
							}
						}
						if(map.centerMapMinZoom != "") {
							if(map.getZoom() < map.centerMapMinZoom) {
								map.setZoom(map.centerMapMinZoom);
							}
						}
					}
				}
				i = i + 1;
			}
		}
	}


})(jQuery);